import apiSlice from "./api/api";
import alertify from "alertifyjs";
import { CHANGE_PASSWORD, DETAILS, FIRST_LOGIN_PASSWORD, LOGIN, REGISTER_EMPLOYEE, VERIFY_EMPLOYEE } from "./ENDPOINTS";
import { login } from "../redux/slices/user.slice";

const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Login user
    login: builder.mutation({
      query: (userData) => ({
        url: LOGIN,
        body: userData,
        method: "POST",
      }),
      onQueryStarted: async (credentials, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          if (data.success) {
            // Check if user needs to change password
            if (data.data.must_change_password) {
              // Store token temporarily for password change
              localStorage.setItem("temp_token", data.data.token);
              localStorage.setItem("must_change_password", "true");
              window.location.href = "/change-password-first-login";
              return;
            }

            dispatch(
              login({
                token: data.data.token,
                user: data.data.user,
                isAuthenticated: true,
              })
            );
            localStorage.setItem("colorschema", "orange");
            localStorage.setItem("layout", "vertical");
            localStorage.setItem("layoutwidth", "fixed");
            localStorage.setItem("layoutpos", "fluid");
            localStorage.setItem("topbartheme", "light");
            localStorage.setItem("layoutSized", "lg");
            localStorage.setItem("layoutStyling", "default");
            localStorage.setItem("layoutSidebarStyle", "dark");
          } else {
            alertify.error(data.message)
          }
        } catch (error) {
          alertify.error(error?.error?.data?.message || "Login failed. Please check your credentials.");
        }
      },
      transformResponse: (response) => {
        return response;
      },
      invalidatesTags: ["User"],
    }),

    // Verify employee by emp_code
    verifyEmployee: builder.mutation({
      query: (data) => ({
        url: VERIFY_EMPLOYEE,
        body: data,
        method: "POST",
      }),
    }),

    // Register employee with email
    registerEmployee: builder.mutation({
      query: (data) => ({
        url: REGISTER_EMPLOYEE,
        body: data,
        method: "POST",
      }),
    }),

    // Change password on first login
    firstLoginPassword: builder.mutation({
      query: (data) => ({
        url: FIRST_LOGIN_PASSWORD,
        body: data,
        method: "POST",
      }),
    }),

    // Change password
    changePassword: builder.mutation({
      query: (data) => ({
        url: CHANGE_PASSWORD,
        body: data,
        method: "POST",
      }),
    }),

    // get user details
    getUserDetails: builder.query({
      query: () => ({
        url: DETAILS,
        method: "GET",
      }),
      providesTags: ["User"],
    }),
  }),
});

export const {
  useGetUserDetailsQuery,
  useLoginMutation,
  useChangePasswordMutation,
  useVerifyEmployeeMutation,
  useRegisterEmployeeMutation,
  useFirstLoginPasswordMutation,
} = authApiSlice;
